export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.19-1106.13",
  commitId: "d6c797f41c5d32085ccb45fac45388a4c7784cf0",
  commitTime: "2026-08-19T11:06:13.000Z",
});
